import { z } from 'zod';
export const formKey = {
    label: 'label',
    color: 'color',
};
export const getFormSchema = () => z.object({
    label: z.string().min(1, 'Ce champ est obligatoire').max(100),
    color: z.string().max(1000).optional(),
});
//# sourceMappingURL=team.form.js.map